import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal, RevealLines } from "../components/Reveal";
import Marquee from "../components/Marquee";
import { useI18n } from "../i18n";

export default function Investment() {
  const { t } = useI18n();
  return (
    <>
      <PageHero label={t.investment.label} title={t.investment.heading} image="https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="Premium real estate" />
      <section className="bg-[#F7F5F0] py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-6">
            <Reveal><p className="font-body text-[#2A2A2A]/80 text-xl md:text-2xl leading-relaxed">{t.investment.body}</p></Reveal>
            <div className="mt-12 space-y-6">
              {[t.services.list[4], t.services.list[5], t.services.list[6]].map((s, i) => (
                <Reveal key={i} delay={i * 0.1}>
                  <div className="border-t border-[#2A2A2A]/12 pt-5">
                    <h3 className="font-serif-display text-[#062029] text-2xl md:text-3xl">{s.t}</h3>
                    <p className="font-body text-[#2A2A2A]/60 mt-2">{s.d}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
          <div className="md:col-span-6">
            <Reveal>
              <div className="relative overflow-hidden h-[60vh] md:h-[75vh] group">
                <img src="https://images.unsplash.com/photo-1780863169728-29e9af6f70a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="Business district" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.4s]" />
                <div className="absolute inset-0 bg-[#062029]/15" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <Marquee items={t.marquee} />
      <section className="bg-[#062029] py-28 grain overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 text-center">
          <RevealLines className="font-serif-display text-[#F7F5F0] text-3xl md:text-5xl leading-tight" lines={["Coordinated, never promised."]} />
          <Reveal delay={0.2}>
            <Link to="/contact" data-testid="investment-cta" className="inline-flex items-center gap-3 mt-10 border border-[#C5A880]/60 text-[#F7F5F0] px-8 py-4 text-[12px] tracking-widest uppercase hover:bg-[#C5A880] hover:text-[#062029] transition-colors duration-500">
              {t.nav.cta} <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
